var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex",attrs:{"id":"error"}},[_vm._v(" 网上开庭平台 ")])}
var staticRenderFns = []

export { render, staticRenderFns }